export default {
  xs: '4px',
  s: '8px',
  m: '16px',
  l: '24px',
  xl: '32px',
  xxl: '40px',
  xxl2: '48px',
  xxl3: '56px',
  xxl4: '64px',
  xxl5: '72px',
  xxl6: '80px',
  xxl7: '88px',
  xxl8: '96px'
};